import * as React from "react";
import RouteIcon from "@mui/icons-material/Route";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Button, TableCell, TableRow } from "@mui/material";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";

export function Row(props) {
  const {
    row,
    setShowModalPatient,
    setSelectedPatient,
    setShowModalViewFile,
    setShowModalDeletePatient,
  } = props;
  const { rol } = useSelector((state) => state.userReducer);
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.firstName ?? ""}
        </TableCell>
        {/* <TableCell align="right">{row?.firstName ?? ""}</TableCell> */}
        <TableCell align="center">{row?.lastName ?? ""}</TableCell>
        <TableCell align="center">{row?.email}</TableCell>
        <TableCell align="center">{row?.phoneNumber ?? ""}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              {/* <Typography variant="h6" gutterBottom component="div">
                  Acciones
                </Typography> */}

              <Box
                sx={{
                  justifyContent: "center",
                  display: "flex",
                  gap: 4,
                  padding: 2,
                }}
              >
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  onClick={() => {
                    setSelectedPatient({
                      _id: row?._id,
                      firstName: row?.firstName,
                    });
                    setShowModalPatient(true);
                  }}
                  startIcon={<MedicalServicesIcon />}
                >
                  Historial
                </Button>
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  startIcon={<FileCopyIcon />}
                  onClick={() => {
                    setSelectedPatient({
                      _id: row?._id,
                      firstName: row?.firstName,
                    });
                    setShowModalViewFile(true);
                  }}
                >
                  Ver Archivos
                </Button>
                {rol === "Coach" && (
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#e7ef7d" }}
                    startIcon={<RouteIcon />}
                    onClick={() => {
                      navigate("/dashboard-provider/asigned-route-provider", {
                        state: { userSelected: row, isRoutesAssigned: false },
                      });
                    }}
                  >
                    Asugnar Ruta
                  </Button>
                )}
                {rol === "Coach" && (
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#e7ef7d" }}
                    startIcon={<RouteIcon />}
                    onClick={() => {
                      navigate("/dashboard-provider/asigned-route-provider", {
                        state: { userSelected: row, isRoutesAssigned: true },
                      });
                    }}
                  >
                    Ver rutas
                  </Button>
                )}

                <Button
                  variant="outlined"
                  sx={{ borderColor: "white", color: "white" }}
                  onClick={() => {
                    setSelectedPatient({
                      _id: row?._id,
                      firstName: row?.firstName,
                    });
                    setShowModalDeletePatient(true);
                  }}
                  startIcon={<PersonRemoveIcon />}
                >
                  Eliminar {rol === "Coach" ? "corredor" : "paciente"}
                </Button>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
